import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

import "./CustomMarquee.css";
import { rootUrl } from "../../../../App";
import { addDataIntoCache, getCacheData } from "../../../../Redux/cacheSlice";

const CustomMarquee = () => {
    const [winData, setWinData] = useState(null);

    useEffect(() => {
        const fetchWinData = async () => {
            const extension = `/statics/announcements/`;

            const cacheDataOfWinData = await getCacheData("cacheDataOfWinData", `${rootUrl}${extension}`);

            if (cacheDataOfWinData) {

                // Get the current time
                const currentTime = new Date();

                // Assuming you have a cached time stored as a Date object
                const cachedTimeStringOfWinData = cacheDataOfWinData?.updateDate; /* Get the cached time from wherever it's stored */

                // Convert the cached time string to a Date object
                const cachedTimeOfWinData = new Date(cachedTimeStringOfWinData);

                // Define a threshold (in milliseconds) for when to hit the API
                const cacheExpirationThreshold = (60 * 1000) * 5; // 5 miniutes (adjust as needed)

                // Calculate the time difference in milliseconds
                const timeDifferenceOfWinData = currentTime - cachedTimeOfWinData;

                if (timeDifferenceOfWinData < cacheExpirationThreshold) {
                    setWinData(cacheDataOfWinData?.data);
                    return null;
                }
            }

            fetch(`${rootUrl}${extension}`)
                .then(res => {
                    if (!res.ok) throw res;
                    else return res.json();
                })
                .then(data => {
                    if (data?.status === "ok") {
                        // // console.log(visibleData);
                        addDataIntoCache(`cacheDataOfWinData`, `${rootUrl}${extension}`, {
                            data: data?.data,
                            updateDate: new Date()
                        });
                        setWinData(data?.data);
                    }
                })
                .catch(error => {
                    console.log(error.type);
                })
        }
        fetchWinData();
    }, []);

    return (
        <>
            <Marquee
                loop={0}
                speed={40}
                delay={1}
                pauseOnHover={true}
                className="custom-marquee-style"
            >
                <div className="marquee">
                    <div className="marquee__content"
                    >
                        {
                            winData &&
                            <p className="no-list-inline">
                                <span className="fw-bold">{winData?.[0]?.announcement}</span>
                                <span className="invisible">{winData?.[0]?.announcement?.slice(0, 100)}</span>
                            </p>
                        }
                    </div>
                </div>
            </Marquee>
            {/* <div className="marquee">
                <div className="marquee__content" style={{ width: `calc(${winData?.length} * 650px)` }}>
                    {
                        winData &&
                        <p className="list-inline">
                            <span>{winData?.[0]?.announcement}</span>
                        </p>
                    }
                </div>
            </div> */}
        </>
    );
};

export default CustomMarquee;